/**
 * PORTED — RO-3-00c / #44470.
 * Origin: `excellent/app/_modes/issues-title-toolbar.tsx`.
 *
 * Changes:
 *   `@/projects/db` reads → `useApi(modes.issuesChrome)` (READ)
 *   `CreateMenu`          → omitted (RO-3-00g / create-menu is cause B);
 *                           primary slot is empty until that port lands
 *   `IssuesSubNav`        → local port
 *   next/*                → none
 */

import { SectionActions, TasksHeader, resolveTasksState } from "@excellent/ui";
import { useApi } from "@excellent/ui/api";
import { modes } from "@excellent/ui/api/contracts/modes";
import { IssuesSubNav } from "./work-issues-subnav";

export function IssuesTitleToolbar({
  searchParams,
}: {
  searchParams: Record<string, string | string[] | undefined> | undefined;
  workspaceId: number;
  projectSlug?: string;
}) {
  const sp0 = searchParams ?? {};
  const sp =
    "status" in sp0 || "section" in sp0
      ? sp0
      : { ...sp0, status: "in_progress,review,todo,backlog", range: "all" };
  const state = resolveTasksState(sp);

  const projectSlug =
    typeof state.projectSlug === "string" ? state.projectSlug : undefined;
  const { data } = useApi(modes.issuesChrome, {
    query: projectSlug ? { projectSlug } : {},
  });

  const scope = data?.scope?.kind === "project"
    ? ({ kind: "project" as const, projectSlug: data.scope.projectSlug })
    : ({ kind: "workspace" as const });

  return (
    <SectionActions>
      <TasksHeader
        parts="controls"
        scope={scope}
        assignees={data?.assignees ?? []}
        projects={data?.projects ?? []}
        section={state.section}
        view={state.view}
        range={state.range}
        from={state.from}
        to={state.to}
        statuses={state.statuses}
        assignee={state.assignee}
        projectSlug={state.projectSlug}
        showEmpty={state.showEmpty}
      />
      <IssuesSubNav bare />
    </SectionActions>
  );
}
